<template>
  <div class='PedidosList' :class="{ gray: isPar(chave) }">
    <div class="c-status">
      {{ data.status }}
    </div>
    <div class="c-id">
      <span>#{{ data.id }}</span>
      de
      <span>{{ usuario.nome }} {{ usuario.sobrenome }}</span>
    </div>
    <div style="width: 22.5%" class="mobile-none">
      <div>{{ qtdeItens }} {{ strItens }}</div>
      <div
      v-for="(i, k) in data.itens"
      :key="k"
      >
        {{ i.qtda + 'x' + i.name }}
      </div>
    </div>
    <div style="width: 27.5%" class="mobile-none">
      {{ endereco.endereco }} - {{  endereco.numero  }} - {{  endereco.cidade  }} - {{ endereco.bairro }}
    </div>
    <div class="c-valor">
      {{ (total + data.frete).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}
    </div>
    <div style="width: 10%" class="mobile-none">
      {{ data.dateCreate }}
    </div>
    <div class="acoes">
      <good-icon
      @click="update"
      :options="{ width: '15px', height: '15px', action: true }"
      text="Marcar como completo"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
      <eyes-icon
      @click="view"
      :options="{ width: '18px', height: '18px', action: true }"
      text="Detalhes"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
      <delete-icon
      @click="del"
      :options="{ width: '18px', height: '18px', action: true }"
      text="Excluir"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
    </div> 
  </div>
</template>

<script>
import { mapActions } from 'vuex'
//import StatusIcon from '../../Icons/StatusIcon'
import GoodIcon from '../../Icons/GoodIcon'
import EyesIcon from '../../Icons/EyesIcon'
import DeleteIcon from '../../Icons/DeleteIcon'
export default {
  name: 'PedidosList',
  components: { GoodIcon, EyesIcon, DeleteIcon },
  props: ['data', 'usuario', 'endereco', 'chave'],
  computed: {
    total () {
      return this.data.itens.map(i => i.preco * i.qtda).reduce((t, n) => t + n, 0)
    },
    qtdeItens () {
      return this.data.itens.map(i => i.qtda).reduce((t, n) => t + n, 0)
    },
    strItens () {
      return this.qtdeItens > 1 ? 'itens' : 'item'
    }
  },
  methods: {
    ...mapActions(['UpdateStatusPedido', 'PushMsg', 'SetModal', 'SetPedidoView']),
    update () {
      this.UpdateStatusPedido({ id: this.data.id, status: 1 })
        .then(() => {
          this.PushMsg({ msg: 'Pedido marcado como concluído', color: 'green' })
        })
    },
    del () {
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: 'Tem certeza que deseja excluir o pedido?',
        action: 'DeletePedido',
        payload: this.data.id
      })
    },
    view () {
      let pedido = this.data
      pedido.endereco = this.endereco
      pedido.usuario = this.usuario
      this.SetPedidoView(pedido)
        .then(() => {
          this.$router.push('/painel/pedidos/view')
        })
    },
    isPar (n) {
      let d = n / 2
      return d % 1 === 0
    }
  }
}
</script>

<style scoped>
.PedidosList {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 1%;
}

.gray {
  background-color: #F5F5F5F5;
}

.c-status {
  width: 10%;
}

.c-id {
  width: 15%;
}

.c-valor {
  width: 10%;
}

.acoes {
  width: 6%;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-status {
    width: 20%;
  }
  .c-id {
    width: 50%;
  }
  .c-valor {
    width: 20%;
  }
  .acoes {
    width: 10%;
  }
}
</style>
